import React from "react";
import { NavigationButton } from "./NavigationButton.style";

interface Props {
  onClick: () => any | string;
}

export default NavigationButton;
